<app-photo-gallery-modal [photo]="this.photoSelected" [photos]="this.photos" (onDidDismiss)="this.onDidDismissModalPhoto()"/>

<marv-drawer #drawerPhotoFilters (onDidDismiss)="this.onDidDismissDrawerFilters($event)">    
    <app-photo-gallery-filters [operationsAll]="this.operationsAll" [photoFiltersValues]="this.photoFiltersValues" [hideFiltersStore]="this.hideFiltersStore" (onChangePhotoFilters)="this.onChangePhotoFilters($event)" />
</marv-drawer>

<ion-modal #modalDownloadPhotos  
    class="modal modal_download_photos"
    [canDismiss]="this.canDismissDownloadPhotosModal.bind(this)"
    (didDismiss)="this.onDidDismissDownloadPhotosModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding" scroll-y="false">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeDownloadPhotosModal()"></ion-icon>
            </div>
            <form [formGroup]="this.downloadPhotosForm" (ngSubmit)="this.downloadPhotos()">
                <div class="title_card">{{'DOWNLOAD_PHOTOS' | translate}}</div>
                <marv-select 
                    label="{{'EXPORT_PHOTOS_GROUP' | translate}}" 
                    icon="albums-outline" 
                    formName="groupBy" 
                    [items]="this.photosGroupsItems" 
                ></marv-select>
                
                <div class="modal_download_photos_buttons">
                    <marv-button type="submit" label="{{'DOWNLOAD' | translate}}" icon="download-outline" [isFetching]="this.isFetchingDownload" />
                </div>
            </form>
        </ion-content>
    </ng-template>
</ion-modal>

@if(this.showViews || this.showSizes || this.showFilters){
    <div id="photos_list_title">        

        @if(this.showViews){
            <div id="buttons_select_view">
                <div class="button_select_view" [class.selected]="this.viewSelected === 'group'" (click)="this.selectView('group')">{{'VIEW_GROUP' | translate}}</div>
                <div class="button_select_view" [class.selected]="this.viewSelected === 'mozaic'" (click)="this.selectView('mozaic')">{{'VIEW_MOZAIC' | translate}}</div>
            </div>
        }

        @if(this.showSizes){
            <div id="buttons_select_size">
                <div class="button_select_size small" [class.selected]="this.sizeSelected === 'small'" (click)="this.selectSize('small')">
                    <ion-icon name="images-outline"></ion-icon>
                </div>
                <div class="button_select_size medium" [class.selected]="this.sizeSelected === 'medium'" (click)="this.selectSize('medium')">
                    <ion-icon name="images-outline"></ion-icon>
                </div>        
                <div class="button_select_size big" [class.selected]="this.sizeSelected === 'big'" (click)="this.selectSize('big')">
                    <ion-icon name="images-outline"></ion-icon>
                </div>
            </div>
        }

        <div id="buttons_actions">
            @if(this.showFilters){
                <marv-button label="{{'FILTER_PHOTOS' | translate}}{{(this.photoFiltersValues.nbFiltersFilled > 0 ? ' ('+this.photoFiltersValues.nbFiltersFilled+')' : '')}}" icon="search-outline" hideLabelDevice="phone" (click)="this.showPhotoFilters()" />
            }

            @if(this.showDownload && this.loggedUserService.loggedUser?.photoGalleryBulkDownloadAllowed){
                <marv-button label="{{'DOWNLOAD' | translate}}" icon="download-outline" hideLabelDevice="phone" (click)="this.openDownloadPhotosModal()" />
            }
        </div>
    </div>
}

@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else {
    <div id="photos_list">
        @if(this.photos.length > 0){
            @if(this.viewSelected === 'group'){
                <app-photo-gallery-group [photos]="this.photos" [size]="this.sizeSelected" (onSelectPhoto)="this.selectPhoto($event)"/>
            }
            @else if(this.viewSelected === 'mozaic'){
                <app-photo-gallery-mozaic [photos]="this.photos" [size]="this.sizeSelected" (onSelectPhoto)="this.selectPhoto($event)"/>
            }
        }
        @else{
            <marv-message type="info">{{'MSG_NO_PHOTO' | translate}}</marv-message>
        }
    </div>
}